import React from 'react';
import Icon from '../../../components/AppIcon';

const StatusSummaryBar = ({ 
  cajaAbierta = true, 
  turno = 'Matutino',
  cajero = 'Usuario',
  montoInicial = 0,
  currentTime
}) => {
  return (
    <div className="bg-card rounded-lg p-4 border border-border shadow-elevation-1">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-3 md:space-y-0">
        <div className="flex items-center space-x-3">
          <div className={`w-3 h-3 rounded-full ${cajaAbierta ? 'bg-success' : 'bg-error'} animate-pulse`} />
          <div>
            <p className="text-sm font-semibold text-foreground">
              Estado de Caja: {cajaAbierta ? 'Abierta' : 'Cerrada'}
            </p>
            <p className="text-xs text-muted-foreground">
              Turno {turno} - {cajero}
            </p>
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-4 md:gap-6">
          <div className="flex items-center space-x-2">
            <Icon name="DollarSign" size={16} color="var(--color-success)" />
            <div>
              <p className="text-xs text-muted-foreground">Monto Inicial</p>
              <p className="text-sm font-semibold text-foreground whitespace-nowrap">
                ${montoInicial?.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDiges: 2 })}
              </p>
            </div>
          </div>

          <div className="flex items-center space-x-2">
            <Icon name="Clock" size={16} color="var(--color-primary)" />
            <div>
              <p className="text-xs text-muted-foreground">Hora Actual</p>
              <p className="text-sm font-semibold text-foreground whitespace-nowrap">
                {currentTime}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatusSummaryBar;